const siteBody = document.querySelector('body');
function getCookies() {
    const cookies = document.cookie.split(';');
    let cookieObj = {};
    cookies.forEach(cookie => {
      const [key, value] = cookie.trim().split('=');
      cookieObj[key] = value;
    });
    return cookieObj;
}

const cookies = getCookies();
if (cookies['discount_code']) {
    if (cookies['discount_code'] === 'MAREA1023' || cookies['discount_code'] === 'madre10') {
      siteBody.classList.add('discount--ten');
    }
    if (cookies['discount_code'] === 'MAREA1532') {
      siteBody.classList.add('discount--fifteen');
    }
    if (cookies['discount_code'] === 'WINMS' || cookies['discount_code'] === 'SS20' || cookies['discount_code'] === 'hotsale2025'|| cookies['discount_code'] === 'hotsaleap') {
      siteBody.classList.add('discount--twenty');
    }
    if (cookies['discount_code'] === 'MAREA2578') {
      siteBody.classList.add('discount--twenty-five');
    }
    if (cookies['discount_code'] === 'MAREA3056') {
      siteBody.classList.add('discount--thirty');
    }
    if (cookies['discount_code'] === 'MAREA3591') {
      siteBody.classList.add('discount--thirty-five');
    }
    if (cookies['discount_code'] === 'MAREA4077') {
      siteBody.classList.add('discount--fourty');
    }
}
// recoment Section
const recomendProduct = document.querySelector('[js-recomend-product]');
if (recomendProduct) {
  const tabHeaders = recomendProduct.querySelectorAll('[js-tab-header]');
  const tabItems = recomendProduct.querySelectorAll('[js-tab-items]');

  tabHeaders.forEach((header, index) => {
    header.addEventListener('click', () => {
      
      tabHeaders.forEach(evt => evt.classList.remove('active'));
      tabItems.forEach(item => item.classList.remove('active'));
      header.classList.add('active');
      tabItems[index].classList.add('active');
    });
  });
}
document.addEventListener("DOMContentLoaded", function () {
  if (document.documentElement.clientWidth < 768) {
      const sliders = document.querySelectorAll("[js-recomend-swiper]");   

      sliders.forEach((slider) => {
          const progressBar = slider.querySelector("[js-recomend-progressbar]");
          new Swiper(slider, {
              slidesPerView: 1.189, 
              watchSlidesProgress: true,
              draggable: true,
              autoHeight: false,
              watchOverflow: true,
              threshold: 10, 
              mousewheel: {
                  forceToAxis: true
              },
              loop: false,
              centeredSlides: false,
              pagination: {
                  el: progressBar,
                  type: "progressbar",
              },
              navigation: {
                nextEl: "[js-swiper-nav-right]", 
                prevEl: "[js-swiper-nav-left]",
              }
          });
      });
  }
});


// best seller

var swiper = new Swiper("[js-best-seller-container]", {
  slidesPerView: 2.2, 
  spaceBetween: 20, 
  watchSlidesProgress: true,
    draggable: true,
    autoHeight: false,  
    watchOverflow: true,
    threshold: 10, 
    mousewheel: {
        forceToAxis: true
    },
  navigation: {
    nextEl: "[js-best-seller-next-button]", 
    prevEl: "[js-best-seller-prev-button]",
  },
  breakpoints: { 
    0: {
        slidesPerView: 1,
        spaceBetween: 14,
    }, 
    768: {
        slidesPerView: 1.1,  
        spaceBetween: 10, 
    },
    1024: {
        slidesPerView: 2,  
        spaceBetween: 20, 
    },
    1279: {
        slidesPerView: 2.2,  
        spaceBetween: 20,  
    },
    },
});
// custom product card

function centerProgressBar(progress) {
  const progressBarFill = document.querySelector("[js-progressbar] .swiper-pagination-progressbar-fill");
  if (progressBarFill) {
      const offsetPercentage = (progress - 0.5) * 100; 
      progressBarFill.style.transform = `translateX(${offsetPercentage}%) scaleX(${progress})`;
      progressBarFill.style.transformOrigin = 'center'; 
  }
} 

document.querySelectorAll("[js_product_slider]").forEach((swiperEl) => {
  const sectionId = swiperEl.getAttribute("data-section");
  const progressbarEl = document.querySelector(`#progressbar-${sectionId}`);
  new Swiper(swiperEl, {
    slidesPerView: 3,
    watchSlidesProgress: true, 
    draggable: true,
    autoHeight: false,
    watchOverflow: true,
    threshold: 10,
    mousewheel: {
        forceToAxis: true
    },
    pagination: {
      el: progressbarEl,
      type: "progressbar",
    },
    navigation: {
      nextEl: `[js-slider_next_btn][data-section="${sectionId}"]`,
      prevEl: `[js-slider_prev_btn][data-section="${sectionId}"]`,
    },  
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 16, loop: false, centeredSlides: false },
      360: { slidesPerView: 1.166, spaceBetween: 16, loop: false, centeredSlides: false },
      768: { slidesPerView: 2, spaceBetween: 16, loop: false, centeredSlides: false },
      834: { slidesPerView: 2.5, spaceBetween: 20 }, 
      990: { slidesPerView: 3.1, spaceBetween: 21 },  
      1220: { slidesPerView: 3, spaceBetween: 21 },    
      1450: { slidesPerView: 3.5, spaceBetween: 21 },   
      1600: { slidesPerView: 4, spaceBetween: 21 },
    },
    on: {
      progress: function (swiper, progress) {
        if (window.matchMedia("(max-width: 768px)").matches) {
          centerProgressBar(progress, sectionId);
        }
      },
    },
  });
});

function centerProgressBar(progress, sectionId) {
  const progressBarFill = document.querySelector(`#progressbar-${sectionId} .swiper-pagination-progressbar-fill`);
  if (progressBarFill) {
    const offsetPercentage = (progress - 0.5) * 100;
    progressBarFill.style.transform = `translateX(${offsetPercentage}%) scaleX(${progress})`;
    progressBarFill.style.transformOrigin = 'center';
  }
}  
// Reviews Section
var swiper = new Swiper("[js-slider-reviews]", {
  slidesPerView: 3.1,
  spaceBetween: 20,
  watchSlidesProgress: true, // Progress track karna 
    draggable: true, // Dragging enable karna
    autoHeight: false, // Slide ka height automatic adjust nahi hoga
    watchOverflow: true, // Agar content kam ho toh overflow control kare
    threshold: 10, // Drag start hone ka minimum distance
    mousewheel: {
        forceToAxis: true // Mousewheel ko axis ke along restrict karna
    },
  navigation: {
        nextEl: '[slider-next-icon]',
        prevEl: '[slider-prev-icon]',  
  },
  breakpoints: {
    0: {
        slidesPerView: 1,
        spaceBetween: 20,
    },
    580: {
        slidesPerView: 1.5,
        spaceBetween: 20,  
    },
    768: {
        slidesPerView: 2,
        spaceBetween: 20,
    },
    991: {
        slidesPerView: 2.6,
        spaceBetween: 20,
    },
    1220: {
        slidesPerView: 3.1,
        spaceBetween: 20,
    },
},

});
// Table Section 
document.addEventListener("DOMContentLoaded", function () {
  if(document.documentElement.clientWidth < 991 ) {
    const swiper = new Swiper("[js-table_swiper]", {
      slidesPerView: 1.1,
      watchSlidesProgress: true,
      draggable: true,
      autoHeight: false,
      watchOverflow: true,
      threshold: 10, 
      navigation: {
        nextEl: "[custom-table___btn-next]",
        prevEl: "[custom-table___btn-prev]",
      },
      mousewheel: {
          forceToAxis: true
      },
      pagination: { 
        el: "[js-table_pagination]",
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
      },
      autoplay: false,
      loop: true,
    });
  }

  const recommendProduct = document.querySelector('[js-table-tab-main]');
  if (recommendProduct) {
    const tabButtons = recommendProduct.querySelectorAll('[js-tab-btn]');
    const tabContents = recommendProduct.querySelectorAll('[js-tab-content]');

    tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));
        button.classList.add('active');
        if (tabContents[index]) { 
          tabContents[index].classList.add('active');
        }
      });
    }); 
  }
});
// featured overviews
function centerProgressBar(progress) {
  const progressBarFill = document.querySelector("[js-featured-progressbar] .swiper-pagination-progressbar-fill");
  if (progressBarFill) {
      const offsetPercentage = (progress - 0.5) * 100;
      progressBarFill.style.transform = `translateX(${offsetPercentage}%) scaleX(${progress})`;
      progressBarFill.style.transformOrigin = 'center';
  }
} 
var swiper = new Swiper("[js-featured-container]", {
  watchSlidesProgress: true,
    draggable: true,
    autoHeight: false,
    watchOverflow: true,
    threshold: 10, 
    mousewheel: {
        forceToAxis: true
  },
  pagination: {
      el: "[js-featured-progressbar]",
      type: "progressbar",
  },
  navigation: {
    nextEl: window.matchMedia("(max-width: 768px)").matches 
        ? "[js-category-next-button-mobile]" 
        : "[js-category-next-button-desktop]",
    prevEl: window.matchMedia("(max-width: 768px)").matches 
        ? "[js-category-prev-button-mobile]" 
        : "[js-category-prev-button-desktop]",
  },
  breakpoints: {
      0: {
          slidesPerView: 1,
          spaceBetween: 8,
      },
      429: {
          slidesPerView: 1.189, 
          spaceBetween: 15,  
      },
      768: {
          slidesPerView: 2.1,
          spaceBetween: 10,
      },
      1024: {
          slidesPerView: 2.5, 
          spaceBetween: 15,
      }, 
      1279: {
          slidesPerView: 3.04,   
          spaceBetween: 20,
      },
  },
  on: {
      progress: function (progress) {
          // Check if current breakpoint is mobile
          if (window.matchMedia("(max-width: 768px)").matches) {
              centerProgressBar(progress);
          }
      },
  },
});

// Homepage collection list slider

const srCollectionListMain = document.querySelector('[js-sr-collection-list]')
   if(srCollectionListMain){
    const swiper = new Swiper("[js-category-container]", {
        slidesPerView: 3.45, 
        spaceBetween: 10,
        watchSlidesProgress: true,
          draggable: true,
          autoHeight: false,
          watchOverflow: true,
          threshold: 10, 
          mousewheel: {
              forceToAxis: true
        },
        pagination: {
            el: "[js-category-progressbar]",
            type: "progressbar",
        },
        navigation: {
            nextEl: "[js-category-next-button]",
            prevEl: "[js-category-prev-button]",
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 8,
            },
            430: {
                slidesPerView: 1.06,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 2.5,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 10,
            }, 
            1279: {
              slidesPerView: 3.45,  
                spaceBetween: 10,
            },
        },
    });
}

const stickySidebar = document.querySelector("sticky-sidebar");

if(stickySidebar) {
  const checkForRechargeWidget = () => {
    const widget = stickySidebar.querySelector('recharge-subscription-widget');
  
    if (widget) {
      initializeStickySidebar(widget);
      clearInterval(intervalId);
    }
  };
  
  const intervalId = setInterval(checkForRechargeWidget, 500);
  function initializeStickySidebar(widgetElement) {
    if(!document.body.className.includes("discount--")) return;

    setTimeout(function() {
      const widget = widgetElement.shadowRoot;
      handleSubscriptionPrice(widget)
    }, 2000)
  }

  function handleSubscriptionPrice(widget) {
    const rechargeDiscountBadge = widget.querySelector(".rc-purchase-option__subscription .rc-purchase-option__badge");
        if (rechargeDiscountBadge && rechargeDiscountBadge.textContent.includes("Ahorra hasta")) {
          return; // Ya hay descuento visible, no aplicar otro
    }
    // Aplicar descuento visual a Compra Única si hay clase de descuento
const onetimeBlock = widget.querySelector(".rc-selection__onetime");
console.log("🧩 Bloque Compra Única encontrado:", onetimeBlock);

const onetimePriceEl = onetimeBlock?.querySelector(".rc-price");
console.log("💲 Elemento de precio en Compra Única:", onetimePriceEl);

if (onetimePriceEl && document.body.className.includes("discount--")) {
  const originalPrice = parseFloat(onetimePriceEl.textContent.replace(/[^0-9.]/g, ''));
  console.log("📊 Precio original:", originalPrice);

  let discountFactor = 0;

  if (document.body.classList.contains("discount--ten")) discountFactor = 0.10;
  if (document.body.classList.contains("discount--fifteen")) discountFactor = 0.15;
  if (document.body.classList.contains("discount--twenty")) discountFactor = 0.20;
  if (document.body.classList.contains("discount--twenty-five")) discountFactor = 0.25;
  if (document.body.classList.contains("discount--thirty")) discountFactor = 0.30;
  if (document.body.classList.contains("discount--thirty-five")) discountFactor = 0.35;
  if (document.body.classList.contains("discount--fourty")) discountFactor = 0.40;

  console.log("📉 Discount aplicado:", discountFactor * 100 + "%");

  const discountedPrice = (originalPrice * (1 - discountFactor)).toFixed(2);
  console.log("✅ Nuevo precio con descuento:", discountedPrice);

  onetimePriceEl.innerHTML = `<s>$${originalPrice.toFixed(2)}</s> <strong>$${discountedPrice}</strong>`;
  console.log("🎯 Precio visual actualizado.");
} else {
  console.log("⛔ No se aplicó descuento visual a Compra Única (posiblemente no hay clase activa o no se encontró el precio).");
}

    const subscriptionBlock = widget.querySelector(".rc-purchase-option__subscription");
    const regularPriceEl = widget.querySelector(".rc-price");
    const subscriptionRegularPriceEl = subscriptionBlock.querySelector("[class='rc-price']");
    const subscriptionBadge = subscriptionBlock.querySelector(".rc-purchase-option__badge");

    const regularPrice = parseFloat(regularPriceEl.textContent.replace(/[^0-9.]/g, ''));
    const subscriptionRegularPrice = parseFloat(subscriptionRegularPriceEl.textContent.replace(/[^0-9.]/g, ''));
    let discountRegularPrice;
    let discountSubscriptionRegularPrice;
    let discountPercentage;

    if(document.body.classList.contains("discount--ten")) {
      discountRegularPrice = (regularPrice - (regularPrice * 0.1)).toFixed(2);
      discountSubscriptionRegularPrice = (subscriptionRegularPrice - (subscriptionRegularPrice * 0.1)).toFixed(2);
      discountPercentage = '20%';
    }if(document.body.classList.contains("discount--fifteen")) {
      discountRegularPrice = (regularPrice - (regularPrice * 0.15)).toFixed(2);
      discountSubscriptionRegularPrice = (subscriptionRegularPrice - (subscriptionRegularPrice * 0.15)).toFixed(2);
      discountPercentage = '25%';
    }if(document.body.classList.contains("discount--twenty")) {
      discountRegularPrice = (regularPrice - (regularPrice * 0.2)).toFixed(2);
      discountSubscriptionRegularPrice = (subscriptionRegularPrice - (subscriptionRegularPrice * 0.2)).toFixed(2);
      discountPercentage = '30%';
    }if(document.body.classList.contains("discount--twenty-five")) {
      discountRegularPrice = (regularPrice - (regularPrice * 0.25)).toFixed(2);
      discountSubscriptionRegularPrice = (subscriptionRegularPrice - (subscriptionRegularPrice * 0.25)).toFixed(2);
      discountPercentage = '35%';
    }if(document.body.classList.contains("discount--thirty")) {
      discountRegularPrice = (regularPrice - (regularPrice * 0.3)).toFixed(2);
      discountSubscriptionRegularPrice = (subscriptionRegularPrice - (subscriptionRegularPrice * 0.3)).toFixed(2);
      discountPercentage = '40%';
    }if(document.body.classList.contains("discount--thirty-five")) {
      discountRegularPrice = (regularPrice - (regularPrice * 0.35)).toFixed(2);
      discountSubscriptionRegularPrice = (subscriptionRegularPrice - (subscriptionRegularPrice * 0.35)).toFixed(2);
      discountPercentage = '45%';
    }if(document.body.classList.contains("discount--fourty")) {
      discountRegularPrice = (regularPrice - (regularPrice * 0.4)).toFixed(2);
      discountSubscriptionRegularPrice = (subscriptionRegularPrice - (subscriptionRegularPrice * 0.4)).toFixed(2);
      discountPercentage = '50%';
    };

    const regularPriceTextNode = Array.from(regularPriceEl.childNodes).find(
      node => node.nodeType === Node.TEXT_NODE && node.textContent.trim().startsWith('$')
    );
    const subscriptionRegularPriceTextNode = Array.from(subscriptionRegularPriceEl.childNodes).find(
      node => node.nodeType === Node.TEXT_NODE && node.textContent.trim().startsWith('$')
    );
    
    if (regularPriceTextNode) {
      regularPriceTextNode.textContent = `$ ${discountRegularPrice}`;
    }
    if (subscriptionRegularPriceTextNode) {
      // subscriptionRegularPriceTextNode.textContent = `$ ${discountSubscriptionRegularPrice}`;
    }

    // regularPriceEl.textContent = `$ ${discountRegularPrice}`;
    // subscriptionRegularPriceEl.textContent = `$ ${discountSubscriptionRegularPrice}`;

    // subscriptionBadge.textContent = `Ahorra hasta ${discountPercentage}`;
  }

  function handleSubscritionDetails(widget) {
    const subscriptionBlock = widget.querySelector(".rc-purchase-option__subscription");
    const subscriptionRegularPriceEl = subscriptionBlock.querySelector("[class='rc-price']:not(.strike-through)");
    const subscriptionComparePrice = subscriptionBlock.querySelector("[class*='rc-price strike-through']").innerText;

    let subscriptionRegularPrice;
    if(widget.querySelector(".rc-purchase-option__subscription[rc-selected]")) {
      subscriptionRegularPrice = Array.from(subscriptionRegularPriceEl.childNodes)
      .filter(node => node.nodeType === Node.TEXT_NODE)
      .map(node => node.textContent.trim())
      .find(text => text.startsWith('$'));
    }else {
      subscriptionRegularPrice = widget.querySelector(".rc-purchase-option__prices .rc-price").innerText;
    }
    // const rcPlans = subscriptionBlock.querySelector("rc-selling-plans")?.shadowRoot;
    // const rcBenefits = subscriptionBlock.querySelector("rc-benefits")?.shadowRoot;
    // const subscriptionButtonDiscount = rcPlans?.querySelectorAll(".rc-plans-button__discount");
    // const listItem = rcBenefits?.querySelector("li:first-child");

    // let discountPercentage;

    // if(document.body.classList.contains("discount--ten")) {
    //   discountPercentage = '20%';
    // }if(document.body.classList.contains("discount--fifteen")) {
    //   discountPercentage = '25%';
    // }if(document.body.classList.contains("discount--twenty")) {
    //   discountPercentage = '30%';
    // }if(document.body.classList.contains("discount--twenty-five")) {
    //   discountPercentage = '35%';
    // }if(document.body.classList.contains("discount--thirty")) {
    //   discountPercentage = '40%';
    // }if(document.body.classList.contains("discount--thirty-five")) {
    //   discountPercentage = '45%';
    // }if(document.body.classList.contains("discount--fourty")) {
    //   discountPercentage = '50%';
    // };

    // subscriptionButtonDiscount?.forEach( el => el.textContent = `Ahorra ${discountPercentage}`);
    // listItem ? listItem.textContent = `Ahorra ${discountPercentage} en cada pedido` : null;

    const activePriceBlock = document.querySelector("[data-variant-info]:not(.hidden)");
    if(document.body.classList.contains("discount--ten")) {
       const discountEl = activePriceBlock.querySelector(".discount--ten");
       document.querySelector("[js-atc-btn-price].discount--ten").textContent = subscriptionRegularPrice;
       discountEl.querySelector(".discount--ten [js-variant-price]").textContent = subscriptionRegularPrice;
      
       if(document.querySelector("[js-atc-btn-compare-price].discount--ten")) {
        document.querySelector("[js-atc-btn-compare-price].discount--ten").textContent = subscriptionComparePrice;
       }
       if(discountEl.querySelector("[js-variant-compare-price]")) {
        discountEl.querySelector("[js-variant-compare-price]").textContent = subscriptionComparePrice;
       }

    }else if(document.body.classList.contains("discount--fifteen")) {
       const discountEl = activePriceBlock.querySelector(".discount--fifteen");
       document.querySelector("[js-atc-btn-price].discount--fifteen").textContent = subscriptionRegularPrice;
       discountEl.querySelector(".discount--fifteen [js-variant-price]").textContent = subscriptionRegularPrice;
      
       if(document.querySelector("[js-atc-btn-compare-price].discount--fifteen")) {
        document.querySelector("[js-atc-btn-compare-price].discount--fifteen").textContent = subscriptionComparePrice;
       }
       if(discountEl.querySelector("[js-variant-compare-price]")) {
        discountEl.querySelector("[js-variant-compare-price]").textContent = subscriptionComparePrice;
       }

    }else if(document.body.classList.contains("discount--twenty")) {
       const discountEl = activePriceBlock.querySelector(".discount--twenty");
       document.querySelector("[js-atc-btn-price].discount--twenty").textContent = subscriptionRegularPrice;
       discountEl.querySelector(".discount--twenty [js-variant-price]").textContent = subscriptionRegularPrice;
      
       if(document.querySelector("[js-atc-btn-compare-price].discount--twenty")) {
        document.querySelector("[js-atc-btn-compare-price].discount--twenty").textContent = subscriptionComparePrice;
       }
       if(discountEl.querySelector("[js-variant-compare-price]")) {
        discountEl.querySelector("[js-variant-compare-price]").textContent = subscriptionComparePrice;
       }

    }else if(document.body.classList.contains("discount--twenty-five")) {
       const discountEl = activePriceBlock.querySelector(".discount--twenty-five");
       document.querySelector("[js-atc-btn-price].discount--twenty-five").textContent = subscriptionRegularPrice;
       discountEl.querySelector(".discount--twenty-five [js-variant-price]").textContent = subscriptionRegularPrice;
      
       if(document.querySelector("[js-atc-btn-compare-price].discount--twenty-five")) {
        document.querySelector("[js-atc-btn-compare-price].discount--twenty-five").textContent = subscriptionComparePrice;
       }
       if(discountEl.querySelector("[js-variant-compare-price]")) {
        discountEl.querySelector("[js-variant-compare-price]").textContent = subscriptionComparePrice;
       }

    }else if(document.body.classList.contains("discount--thirty")) {
       const discountEl = activePriceBlock.querySelector(".discount--thirty");
       document.querySelector("[js-atc-btn-price].discount--thirty").textContent = subscriptionRegularPrice;
       discountEl.querySelector(".discount--thirty [js-variant-price]").textContent = subscriptionRegularPrice;
      
       if(document.querySelector("[js-atc-btn-compare-price].discount--thirty")) {
        document.querySelector("[js-atc-btn-compare-price].discount--thirty").textContent = subscriptionComparePrice;
       }
       if(discountEl.querySelector("[js-variant-compare-price]")) {
        discountEl.querySelector("[js-variant-compare-price]").textContent = subscriptionComparePrice;
       }

    }else if(document.body.classList.contains("discount--thirty-five")) {
       const discountEl = activePriceBlock.querySelector(".discount--thirty-five");
       document.querySelector("[js-atc-btn-price].discount--thirty-five").textContent = subscriptionRegularPrice;
       discountEl.querySelector(".discount--thirty-five [js-variant-price]").textContent = subscriptionRegularPrice;
      
       if(document.querySelector("[js-atc-btn-compare-price].discount--thirty-five")) {
        document.querySelector("[js-atc-btn-compare-price].discount--thirty-five").textContent = subscriptionComparePrice;
       }
       if(discountEl.querySelector("[js-variant-compare-price]")) {
        discountEl.querySelector("[js-variant-compare-price]").textContent = subscriptionComparePrice;
       }

    }else if(document.body.classList.contains("discount--fourty")) {
       const discountEl = activePriceBlock.querySelector(".discount--fourty");
       document.querySelector("[js-atc-btn-price].discount--fourty").textContent = subscriptionRegularPrice;
       discountEl.querySelector(".discount--fourty [js-variant-price]").textContent = subscriptionRegularPrice;
      
       if(document.querySelector("[js-atc-btn-compare-price].discount--fourty")) {
        document.querySelector("[js-atc-btn-compare-price].discount--fourty").textContent = subscriptionComparePrice;
       }
       if(discountEl.querySelector("[js-variant-compare-price]")) {
        discountEl.querySelector("[js-variant-compare-price]").textContent = subscriptionComparePrice;
       }
    }else {
       const discountEl = activePriceBlock.querySelector(".discount__nil");
       document.querySelector("[js-atc-btn-price].discount__nil").textContent = subscriptionRegularPrice;
       discountEl.querySelector(".discount__nil [js-variant-price]").textContent = subscriptionRegularPrice;
      
       if(document.querySelector("[js-atc-btn-compare-price].discount__nil")) {
        document.querySelector("[js-atc-btn-compare-price].discount__nil").textContent = subscriptionComparePrice;
       }
       if(discountEl.querySelector("[js-variant-compare-price]")) {
        discountEl.querySelector("[js-variant-compare-price]").textContent = subscriptionComparePrice;
       }
    }
  }
  
  document.addEventListener("click", function({ target }) {
    if(target.tagName === 'RECHARGE-SUBSCRIPTION-WIDGET') {
      initSubscriptionMeta();
    }
  });

  window.initSubscriptionMeta = function() {
    const widgetElement = document.querySelector('recharge-subscription-widget');
    const widget = widgetElement.shadowRoot;

    setTimeout(function() {
      handleSubscritionDetails(widget)
    }, 1000)
  }
}

function initCartSlider() {
  new Swiper("[js-cart-sample-slider]", {
    slidesPerView: 3.34,
    spaceBetween: 12,
    watchSlidesProgress: true, 
    draggable: true,
    watchOverflow: true,
    threshold: 10,
    mousewheel: {
        forceToAxis: true
    },
    pagination: {
        el: "[js-cart-sample-progressbar]",
        type: "progressbar",
    },
  });

  new Swiper("[js-cart-recommendation-slider]", {
    slidesPerView: 3.34,
    spaceBetween: 12,
    watchSlidesProgress: true, 
    draggable: true,   
    watchOverflow: true,
    threshold: 10,
    mousewheel: {
        forceToAxis: true
    },
    pagination: {
        el: "[js-cart-recommendation-progressbar]",
        type: "progressbar",
    },
  });
};

initCartSlider();
document.addEventListener('cart-slider:init', initCartSlider)